import { Identifier, RaRecord } from 'react-admin';
import { BillingClientForm } from '../utils/DataTypes';

export const feesOmittedFields = [
  'gpCustomerId',
  'cycle',
  'breakouts',
  'gpDescriptions',
  'uploadedReports',
  'broker',
  'tpa',
  'contractType',
  'contractEffectiveDate',
  'fullyExecuted',
  'paymentTerms',
  'adminFeeType',
  'adminFeeMinimum',
  'adminFeeAmount',
  'narrowFee',
  'kinetiqHealthFee',
  'turverisFee',
  'tpaOrBrokerFee',
  'pbxFee',
  'totalFee',
  'otherMiscFeeAmount',
  'otherMiscFeeDescription',
  'paClinicalFee',
  'paSpecialtyFee',
  'paStandardFee',
  'paAppeal1Fee',
  'paAppeal2Fee',
  'trueAssistAmount',
  'trueAdvocateAmount',
  'trueAdvocateMaxAmount',
  'trueAdvocateDaySuppplyCap',
  'trueAdvocateBillingMethod',
  'trueAdvocatePMPM',
  'trueCodesAmount',
  'trueCodesMaxAmount',
  'trueCodesDaySupplyCap',
  'trueCodesBillingMethod',
  'trueGenomicsAmount',
  'trueGenomicsAmountType',
  'trueGenomicsPerTestAmount',
  'diabetesManagement',
  'idCardsFee',
  'initialIdCardFee',
  'mailings',
  'creditableCoverageFee',
  'posRebates',
  'welcomePacket',
  'misc',
];

export const feesFieldConfigurations = [
  { source: 'client', label: 'Client #' },
  { source: 'clientName', label: 'Client Name' },
  { source: 'client', label: 'Billing Client Number' },
  { source: 'gpCustomerId', label: 'Accounting System Client ID' },
  { source: 'cycle', label: 'Cycle' },
  { source: 'breakouts', label: 'Invoice Breakout' },
  { source: 'gpDescriptions', label: 'Invoice Breakout Description' },
  { source: 'uploadedReports', label: 'Uploaded Reports' },
  { source: 'broker', label: 'Broker' },
  { source: 'contractType', label: 'Contract Type' },
  { source: 'contractEffectiveDate', label: 'Contract Effective Date' },
  { source: 'fullyExecuted', label: 'Fully Executed?' },
  { source: 'paymentTerms', label: 'Payment Terms' },
  { source: 'tpa', label: 'TPA' },
  { source: 'adminFeeType', label: 'Admin Fee Type' },
  { source: 'adminFeeMinimum', label: 'Admin Fee Minimum' },
  { source: 'adminFeeAmount', label: 'Admin Fee Amount' },
  { source: 'narrowFee', label: 'Narrow Fee' },
  { source: 'kinetiqHealthFee', label: 'Kinetiq Health Fee' },
  { source: 'turverisFee', label: 'Turveris Fee' },
  { source: 'tpaOrBrokerFee', label: 'TPA or Broker Fee' },
  { source: 'pbxFee', label: 'PGX Fee' },
  { source: 'totalFee', label: 'Total Fees' },
  { source: 'otherMiscFeeAmount', label: 'Other Misc Fee Amount' },
  { source: 'otherMiscFeeDescription', label: 'Other Misc Fee Description' },
  { source: 'paClinicalFee', label: 'PA Clinical Fee' },
  { source: 'paSpecialtyFee', label: 'PA Specialty Fee' },
  { source: 'paStandardFee', label: 'PA Standard Fee' },
  { source: 'paAppeal1Fee', label: 'PA Appeal 1 Fee' },
  { source: 'paAppeal2Fee', label: 'PA Appeal 2 Fee' },
  { source: 'trueAssistAmount', label: 'trueAssist Amount' },
  { source: 'trueAdvocateAmount', label: 'trueAdvocate Amount' },
  { source: 'trueAdvocateMaxAmount', label: 'trueAdvocate Max Amount' },
  { source: 'trueAdvocateDaySuppplyCap', label: 'trueAdvocate Day Supply Cap' },
  { source: 'trueAdvocateBillingMethod', label: 'trueAdvocate Billing Method' },
  { source: 'trueAdvocatePMPM', label: 'trueAdvocate PMPM' },
  { source: 'trueCodesAmount', label: 'trueCodes Amount' },
  { source: 'trueCodesMaxAmount', label: 'trueCodes Max Amount' },
  { source: 'trueCodesDaySupplyCap', label: 'trueCodes Day Supply Cap' },
  { source: 'trueCodesBillingMethod', label: 'trueCodes Billing Method' },
  { source: 'trueGenomicsAmount', label: 'trueGenomics Amount' },
  { source: 'trueGenomicsAmountType', label: 'trueGenomics Amount Type' },
  { source: 'trueGenomicsPerTestAmount', label: 'trueGenomics per Test Amount' },
  { source: 'diabetesManagement', label: 'Diabetes Management per engaged member' },
  { source: 'idCardsFee', label: 'ID Cards Fee' },
  { source: 'initialIdCardFee', label: 'Initial ID Card Fee' },
  { source: 'mailings', label: 'Mailings' },
  { source: 'creditableCoverageFee', label: 'Creditable Coverage Fee' },
  { source: 'posRebates', label: 'POS Rebates' },
  { source: 'welcomePacket', label: 'Welcome Packet' },
  { source: 'misc', label: 'MISC.' },
];

export const feeStrings = Object.freeze({
  errorUpdatingFee: 'Error saving changes. Please try again.',
  successUpdatingFee: (total: number) => `Successfully updated ${total} row(s)!`,
});

export const nonEditableFields = [
  'client',
  'clientName',
  'tpa',
  'adminFeeType',
  'totalFee',
  'gpCustomerId',
  'cycle',
  'breakouts',
  'gpDescriptions',
  'uploadedReports',
  'broker',
  'contractType',
  'paymentTerms',
];

export const currencyFields = [
  'adminFeeMinimum',
  'adminFeeAmount',
  'narrowFee',
  'kinetiqHealthFee',
  'turverisFee',
  'tpaOrBrokerFee',
  'pbxFee',
  'totalFee',
  'otherMiscFeeAmount',
  'paClinicalFee',
  'paSpecialtyFee',
  'paStandardFee',
  'paAppeal1Fee',
  'paAppeal2Fee',
  'trueAdvocateMaxAmount',
  'trueAdvocatePMPM',
  'trueCodesMaxAmount',
  'trueGenomicsAmount',
  'trueGenomicsPerTestAmount',
  'diabetesManagement',
  'idCardsFee',
  'initialIdCardFee',
  'mailings',
  'creditableCoverageFee',
  'posRebates',
  'welcomePacket',
];

export const reportHistoryDateRanges = [
  { id: '30', name: 'Last 30 Days' },
  { id: '60', name: 'Last 60 Days' },
  { id: '90', name: 'Last 90 Days' },
  { id: 'custom', name: 'Custom Dates' },
];

export const REPORT_TYPES = {
  FULL_CLAIMS: 'Full Claims',
  POS_REBATE: 'POS Rebate',
  GP_SALES_ORDER: 'GP Sales Order',
  INVOICE_DETAIL: 'Invoice Detail',
  MEMBER_SUMMARY: 'Member Summary',
  PA_REVIEW: 'PA Review',
  PA_CLIENT_BILL: 'PA Client Bill',
  PA_STATUS_REPORT: 'PA Status',
  ASSIST_REVIEW: 'Assist Review',
  ASSIST_CLIENT_BILL: 'Assist Client Bill',
};

export const REPORT_TYPES_WITH_MULTIPLE_FILES = [
  REPORT_TYPES.MEMBER_SUMMARY,
  REPORT_TYPES.PA_CLIENT_BILL,
  REPORT_TYPES.ASSIST_CLIENT_BILL,
];

export const reportTypes = Object.keys(REPORT_TYPES).map((key) => ({
  label: REPORT_TYPES[key as keyof typeof REPORT_TYPES],
  value: REPORT_TYPES[key as keyof typeof REPORT_TYPES],
}));

export const WEEKS = {
  WEEK_1: 'Week 1',
  WEEK_2: 'Week 2',
  WEEK_3: 'Week 3',
  WEEK_4: 'Week 4',
  CUSTOM: 'Custom Dates',
};

export const TOAST_MESSAGES = {
  REPORT_SUBMITTED: 'Request for report generation submitted successfully',
  REPORT_ERROR: 'Error submitting the request',
  NO_CLIENTS_SELECTED: 'You have not selected any clients. Do you wish to generate the report for all clients?',
  CHECK_PA_REVIEW_EXISTS:
    'A PA Review report must be created for this billing date before generating a PA Client Bill.',
  CHECK_ASSIST_REVIEW_EXISTS:
    'An Assist Review report must be created for this billing date before generating an Assist Client Bill.',
  ERROR_CHECKING_PA_REPORT_EXISTS: 'Error checking report existence',
  TPA_FETCH_ERROR: 'Error: Could not fetch TPA list',
  SELECT_TPA_WARNING: 'Please select a TPA to continue.',
};

export const FORM_LABELS = {
  REPORT_TYPE: 'Type of Report',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  CLIENTS: 'Clients',
  SELECT_WEEK: 'Select Week',
  SELECT_MONTH: 'Select Month',
  SELECT_YEAR: 'Select Year',
  GENERATE_REPORT: 'Generate Report',
  CANCEL: 'Cancel',
  CONFIRM_GENERATE_ALL: 'Yes, Proceed',
  BILLING_DATE: 'Billing Date',
  FILTER_BY_CLIENT: 'Filter by Client',
  FILTER_BY_TPA: 'Filter by TPA',
  SELECT_TPA: 'Select TPA',
  CLIENT_NAME: 'Client Name',
  TPA_NAME: 'TPA Name',
  TPAS: 'TPAs',
};

export const BUTTONS = {
  GENERATE_REPORT: 'Generate Report',
  CANCEL: 'Cancel',
  CONFIRM_GENERATE_REPORT: 'Yes, Proceed',
  CONFIRM: 'Yes',
};

export const DIALOG = {
  GENERATE_REPORT_TITLE_CLIENTS: 'Generate Report for All Clients?',
  GENERATE_REPORT_TITLE_TPA: 'Generate Report for All TPAs?',
  GENERATE_REPORT_MESSAGE_CLIENT:
    'You have not selected any clients. Do you wish to generate the report for all clients?',
  GENERATE_REPORT_MESSAGE_TPA: 'You have not selected any TPAs. Do you wish to generate the report for all TPAs?',
  CONFIRM_PA_REPORT_TITLE: 'Confirm Report Creation',
  CONFIRM_PA_REPORT_MESSAGE: 'A PA Billing entry for this date does not exist. Would you like to create this report?',
  CONFIRM_ASSIST_REPORT_TITLE: 'Confirm Report Creation',
  CONFIRM_ASSIST_REPORT_MESSAGE:
    'An Assist Billing entry for this date does not exist. Would you like to create this report?',
};

export const REPORT_STATUS = {
  STARTED: 'Started',
};

export const DEFAULTS = {
  UNKNOWN_USER: 'unknown_user',
};

export const BILLING_CLIENTS_STRINGS = {
  LABELS: {
    BILLING_CLIENT_NUMBER: 'Billing Client Number',
    BILLING_CLIENT_NAME: 'Billing Client Name',
    TPA_NAME: 'TPA Name',
    GP_ID: 'GP ID',
    BILLING_CYCLE: 'Billing Cycle',
    INVOICE_DETAIL_LOCATION: 'Invoice Detail (Location)',
    INVOICE_DETAIL_MEMBER_NAME: 'Invoice Detail (Member Name)',
    INVOICE_BREAKOUT: 'Invoice Breakout',
    INVOICE_BREAKOUT_DESC: 'Invoice Breakout Description',
    CREATED_BY: 'Created By',
    CREATED_DATE: 'Created Date',
    UPDATED_BY: 'Updated By',
    LAST_UPDATED_DATE: 'Last Updated Date',
    ACTIONS: 'Actions',
    EDIT_DIALOG_TITLE: 'Edit Billing Client',
    CANCEL_BUTTON: 'Cancel',
    SAVE_BUTTON: 'Save',
    CLIENT_NAME: 'Client Name',
    GP_ID_FILTER: 'GP ID Filter',
    BILLING_CYCLE_STATUS_FILTER: 'Billing Cycle Status',
    APPLY: 'Apply',
    CLEAR: 'Clear',
  },
  TOAST: {
    NO_CHANGES: 'No edits have been made. Nothing to save.',
    SUCCESS: 'Client updated successfully',
    ERROR: 'Failed to update client',
    FETCH_ERROR: 'Failed to fetch clients with missing info.',
  },
  OPTIONS: {
    BILLING_CYCLE: ['Weekly', 'Bi-Monthly'],
    YES_NO: ['Y', 'N'],
    BREAKOUT: ['G', 'L', 'L-G', 'G-L', ''],
    BREAKOUT_DESCRIPTIONS: {
      SIMPLE: ['Name', 'Number', 'Name-Number', 'Number-Name'],
      COMPLEX: [
        'Location Number - Location Name - Group Number - Group Name',
        'Location Name - Location Number - Group Name - Group Number',
      ],
    },
  },
  FILTER_OPTIONS: {
    GP_ID: [
      { value: 'all', label: 'All Clients' },
      { value: 'missing', label: 'Clients with Missing GP ID' },
    ],
    BILLING_CYCLE: ['Weekly', 'Bi-Monthly'],
    BILLING_CYCLE_STATUS: [
      { value: 'all', label: 'All Clients' },
      { value: 'missing', label: 'Clients with Missing Billing Cycle' },
    ],
  },
  ALERT: {
    TITLE: 'Action Required',
    DESCRIPTION: (count: number) =>
      `There ${count === 1 ? 'is' : 'are'} ${count} client${
        count === 1 ? '' : 's'
      } with missing GP ID or billing cycle.`,
    VIEW_CLIENTS_BUTTON: 'View Clients',
  },
};

export const BILLING_CLIENT_FIELDS: (keyof BillingClientForm)[] = [
  'accounting_client_id',
  'billing_cycle',
  'invoice_detail_location_yn',
  'invoice_detail_member_name_yn',
  'invoice_breakout',
  'invoice_breakout_description',
];

export const memberSummaryFieldLabels: Record<string, string> = {
  client_ssn: 'Client SSN',
  member_ssn: 'Member SSN',
  claim_number: 'Claim Number',
  ndc: 'NDC',
  ndc_no_dash: 'NDC (No Dash)',
  pos_rebate: 'POS Rebate',
  copayassistanceprogram: 'Copay Assistance Program',
  copayassistanceamount: 'Copay Assistance Amount',
  client_true_codes: 'True Codes',
  client_true_guard: 'True Guard',
  client_true_meds: 'True Meds',
  financial_cutoff_date: 'Financial Cutoff Date',
  transaction_status: 'Transaction Status',
  pgx_fee: 'PGX Fee',
  toc: 'TOC',
  pa_count: 'PA Count',
  pa_fees: 'PA fees',
  claim_count: 'Total Claim Count',
  pa_id: 'PA ID',
  dmr_fee: 'DMR Fee',
};

export const fieldCategories = [
  {
    id: 'clientInfo',
    name: 'Client Info',
    fields: [
      'client_name',
      'client_number',
      'client_tin',
      'carrier_number',
      'accumulation_period',
      'plan_year_list_dates',
    ],
  },
  {
    id: 'clientPrograms',
    name: 'Client Programs',
    fields: [
      'client_advocacy',
      'client_mccp',
      'client_on_track_diabetes',
      'client_pos',
      'client_sharx',
      'client_true_assist_specialty',
      'client_true_assist_brands',
      'client_opioids',
      'client_true_codes',
      'client_true_genomics',
      'client_true_guard',
      'client_true_meds',
      'copayassistanceprogram',
    ],
  },
  {
    id: 'memberInfo',
    name: 'Member Info',
    groups: [
      [
        'member_id',
        'member_ssn',
        'member_name',
        'member_dob',
        'member_gender',
        'relationship_code',
        'coverage_code',
        'member_address',
        'member_city',
        'member_state',
        'member_zip',
        'cardholder_name',
        'cardholder_id',
      ],
      [
        'medical_group_number',
        'medical_group_name',
        'plan_location',
        'location_number',
        'location_display_number',
        'location_name',
        'division_number',
        'division_display_number',
        'division_name',
        'toc',
        'member_contract_type',
        'member_contract_description',
      ],
    ],
  },
  {
    id: 'claimInfo',
    name: 'Claim Info',
    fields: [
      'claim_number',
      'rx_claim_number',
      'rx_reversed_claim_number',
      'adjustment_reason',
      'transaction_status',
      'financial_cutoff_date',
      'reporting_period',
      'paid_claim_count',
      'reversal_claim_count',
      'claim_count',
      'pa_id',
    ],
  },
  {
    id: 'drugInfo',
    name: 'Drug Info',
    fields: [
      'rx_number',
      'ndc',
      'ndc_no_dash',
      'drug_name',
      'compound_code',
      'brand_generic_indicator',
      'otc_flag',
      'drug_in_specialty',
      'drug_in_brands',
    ],
  },
  {
    id: 'pharmacyAndFillInfo',
    name: 'Pharmacy & Fill Info',
    fields: [
      'pharmacy_nabp',
      'pharmacy_npi',
      'pharmacy_name',
      'pharmacy_zip',
      'fill_date',
      'fill_number',
      'number_of_refills_authorized',
      'quantity',
      'days_supply',
    ],
  },
  {
    id: 'financials',
    name: 'Financials',
    fields: [
      'claim_cost',
      'patient_liability',
      'patient_paid',
      'other_paid',
      'plan_paid',
      'pos_rebate',
      'client_ingredient_cost',
      'copayassistanceamount',
      'invoice_amount',
      'dmr_fee',
      'mailing_fee',
      'clinical_fee',
      'pharmacy_affiliate_number',
      'misc_3',
    ],
  },
  {
    id: 'trxContractFees',
    name: 'TRX Contract Fees',
    fields: [
      'admin_fee',
      'narrow_fee',
      'kinetiq_health_fee',
      'turveris_fee',
      'tpa_or_broker_fee',
      'pgx_fee',
      'pa_fees',
      'pa_count',
    ],
  },
];

export const fieldKeyMap = {
  // Client Info
  client_name: 'cl.client_name',
  client_number: 'cl.client_number',
  client_tin: 'cl.client_tin',
  carrier_number: 'cl.carrier_number',

  // Client Programs
  client_advocacy: 'cl.client_advocacy',
  client_mccp: 'cl.client_mccp',
  client_on_track_diabetes: 'cl.client_on_track_diabetes',
  client_pos: 'cl.client_pos',
  client_sharx: 'cl.client_sharx',
  client_true_assist_specialty: 'cl.client_true_assist_specialty',
  client_true_assist_brands: 'cl.client_true_assist_brands',
  client_opioids: 'cl.client_opioids',
  client_true_codes: 'cl.client_true_codes',
  client_true_genomics: 'cl.client_true_genomics',
  client_true_guard: 'cl.client_true_guard',
  client_true_meds: 'cl.client_true_meds',
  copayassistanceprogram: 'cl.copayassistanceprogram',

  // Member Info
  member_id: 'cl.member_id',
  member_name: 'cl.member_name',
  member_dob: 'cl.member_dob',
  member_gender: 'cl.member_gender',
  member_ssn: 'cl.member_ssn',
  member_address: 'cl.member_address',
  member_city: 'cl.member_city',
  member_state: 'cl.member_state',
  member_zip: 'cl.member_zip',
  relationship_code: 'cl.relationship_code',
  coverage_code: 'cl.coverage_code',
  cardholder_name: 'cl.cardholder_name',
  cardholder_id: 'cl.cardholder_id',
  medical_group_number: 'cl.medical_group_number',
  medical_group_name: 'cmg.medical_group_name',
  location_number: 'cl.location_number',
  location_display_number: 'clo.location_display_number',
  location_name: 'clo.location_name',
  division_number: 'cl.division_number',
  division_display_number: 'cdi.division_display_number',
  division_name: 'cdi.division_name',
  plan_location: 'cmg.plan_location',
  toc: 'toc.toc',
  member_contract_type: 'toc.member_contract_type',
  member_contract_description: 'toc.member_contract_description',

  // Claim Info
  claim_number: 'cl.claim_number',
  rx_claim_number: 'cl.rx_claim_number',
  rx_reversed_claim_number: 'cl.rx_reversed_claim_number',
  adjustment_reason: 'cl.adjustment_reason',
  accumulation_period: 'cl.accumulation_period',
  plan_year_list_dates: 'cl.plan_year_list_dates',
  transaction_status: 'cl.transaction_status',
  financial_cutoff_date: 'cl.financial_cutoff_date',
  reporting_period: 'reporting_period',
  pa_id: 'pa.pa_id',

  // Drug Info
  rx_number: 'cl.rx_number',
  ndc: 'cl.ndc',
  ndc_no_dash: 'cl.ndc_no_dash',
  drug_name: 'cl.drug_name',
  brand_generic_indicator: 'cl.brand_generic_indicator',
  drug_in_specialty: 'cl.drug_in_specialty',
  drug_in_brands: 'cl.drug_in_brands',
  otc_flag: 'cl.otc_flag',
  compound_code: 'cl.compound_code',

  // Pharmacy & Fill Info
  pharmacy_nabp: 'cl.pharmacy_nabp',
  pharmacy_npi: 'cl.pharmacy_npi',
  pharmacy_name: 'cl.pharmacy_name',
  fill_date: 'cl.fill_date',
  fill_number: 'cl.fill_number',
  number_of_refills_authorized: 'cl.number_of_refills_authorized',
  quantity: 'cl.quantity',
  days_supply: 'cl.days_supply',
  pharmacy_zip: 'rxp.pharmacy_zip',

  // Financials
  claim_cost: 'cl.claim_cost',
  patient_liability: 'cl.patient_liability',
  patient_paid: 'cl.patient_paid',
  other_paid: 'cl.other_paid',
  plan_paid: 'cl.plan_paid',
  pos_rebate: 'cl.pos_rebate',
  client_ingredient_cost: 'cl.client_ingredient_cost',
  copayassistanceamount: 'cl.copayassistanceamount',
  invoice_amount: 'invoice_amount',

  // Contract Fees
  // admin_fee_type: 'trxc.admin_fee_type',
  // admin_fee_minimum: 'trxc.admin_fee_minimum',
  admin_fee: 'trxc.admin_fee',
  narrow_fee: 'trxc.narrow_fee',
  kinetiq_health_fee: 'trxc.kinetiq_health_fee',
  turveris_fee: 'trxc.turveris_fee',
  tpa_or_broker_fee: 'trxc.tpa_or_broker_fee',
  pgx_fee: 'trxc.pgx_fee',
  pa_fees: 'pa.pa_fees',
};

export const MEMBER_SUMMARY_STRINGS = {
  PAGE_TITLE: 'Member Summary Table Configuration',
  SELECT_TARGET_CLIENT: 'Client to Configure',
  SELECT_SOURCE_CLIENT: 'Copy Settings From',
  LOAD_SELECTED_CLIENT_CONFIG: "Load Client's Configuration",
  CLONE_SETTINGS: 'Clone Settings',
  SELECT_ALL: 'Select All',
  DESELECT_ALL: 'Deselect All',
  SAVE_CONFIGURATION: 'Save Configuration',
  NO_CLIENT_SELECTED: 'Please select a client to configure their summary fields.',
  CLONE_NEEDS_TARGET: 'Clone is disabled until the selected client configuration is loaded.',
  CLONE_NEEDS_CONFIG: 'Load the client’s configuration to enable cloning features.',
  CLONE_OPTIONAL_SOURCE: 'Optional: Select another client to copy settings from.',
  CLONE_SAME_CLIENT_ERROR: 'Cannot clone settings from the same client.',
  CLONE_READY_MESSAGE: (source: string, target: string) => `Ready to clone from "${source}" to "${target}".`,
  CLONE_SAME_TPA_ERROR: 'Cannot clone settings from the same TPA.',
  TPA_CLONE_READY_MESSAGE: (source: string, target: string) => `Ready to clone from "${source}" to "${target}".`,
  CONFIGURE_SUMMARY_FIELDS_TITLE: (name: string, number: string) => `Configure Summary Fields for: ${name} (${number})`,
  OVERWRITE_DIALOG_TITLE: 'Overwrite Configuration',
  OVERWRITE_DIALOG_MESSAGE: (source: string, target: string) =>
    `The client (${target}) already has settings displayed or you have unsaved changes. ` +
    `Cloning will overwrite them with settings from ${source}. Do you want to continue?`,
  CANCEL: 'Cancel',
  OVERWRITE_CLONE: 'Overwrite & Clone',
  CLONE_CANCELLED: 'Clone operation cancelled.',
  CLIENT_ID_MISSING_LABEL: '(Missing ID)',
  CLIENT_FILTER: {
    SEARCH_CLIENT: 'Search Client',
    FETCH_ERROR: 'Failed to fetch clients',
  },
  DIALOG_LABELS: {
    CHANGES_FROM_CLONE: 'Changes from clone:',
    LOCAL_UNSAVED_CHANGES: 'Local unsaved changes to be discarded',
    ADDED: 'Added:',
    REMOVED: 'Removed:',
  },
  NO_TPA_SELECTED: 'Please select a tpa to configure their summary fields.',
  SELECT_SOURCE_TPA: 'Select source TPA to clone from',
  TPA_CLONE_NEEDS_CONFIG: 'Clone is disabled until the selected TPA configuration is loaded.',
  TPA_CLONE_OPTIONAL_SOURCE: 'Optional: Select another TPA to copy settings from.',
  FILTER_TYPE: {
    CLIENT: 'client',
    TPA: 'tpa',
  },
  VIEW_TYPE: {
    DETAILED: 'detailed',
    ROLLUP: 'rollup',
  },
};

export const DUMMY_FIELDS = ['dmr_fee', 'mailing_fee', 'clinical_fee', 'pharmacy_affiliate_number', 'misc_3'];

export const MEDICAL_GROUPS_STRINGS = {
  LABELS: {
    BILLING_CLIENT_NAME: 'Billing Client Name',
    BILLING_CLIENT_NUMBER: 'Billing Client Number',
    MEDICAL_GROUP_NUMBER: 'Medical Group Number',
    MEDICAL_GROUP_NAME: 'Medical Group Name',
    PLAN_LOCATION: 'Plan Location',
    CREATED_BY: 'Created By',
    CREATED_ON: 'Created On',
    MODIFIED_BY: 'Last Modified By',
    MODIFIED_ON: 'Last Modified On',
    ACTIONS: 'Actions',
    EDIT_DIALOG_TITLE: 'Edit Medical Group Crosswalk',
    CANCEL_BUTTON: 'Cancel',
    SAVE_BUTTON: 'Save',
  },
  TOAST: {
    NO_CHANGES: 'No changes made.',
    SUCCESS: 'Medical Group Crosswalk updated successfully!',
    ERROR: 'Update failed.',
  },
};

export const HISTORICAL_REPORTS_STRINGS = {
  COPY_PATH: {
    DIRECTORY: 'Copy Directory Path',
    FILE: 'Copy Full Path',
    SUCCESS: 'Path copied to clipboard',
  },
  FILTERS: {
    DATE_RANGE: 'Date Range',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    APPLY: 'Apply',
  },
  COLUMNS: {
    REQUEST_ID: 'Request ID',
    REPORT_NAME: 'Report Name',
    REQUESTED_BY: 'Requested By',
    REQUESTED_DATE: 'Requested Date',
    GENERATED_DATE: 'Generated Date',
    CLIENTS: 'Clients',
    TPAS: 'TPAs',
    START_DATE: 'Start Date',
    END_DATE: 'End Date',
    STATUS: 'Status',
    FILE_NAME: 'File Name',
    COPY_PATH: 'Copy Path',
  },
  TOOLTIP: {
    COPY_DIRECTORY: 'Copy Directory Path',
    COPY_FILE: 'Copy Full Path',
  },
  TOAST: {
    PATH_COPIED: 'Path copied to clipboard',
  },
  PLACEHOLDER: {
    EMPTY: '—',
    ALL_CLIENTS: 'All Clients',
  },
  ERRORS: {
    START_BEFORE_END: 'Start date must be before end date',
  },
};

export const GENERATE_REPORTS_VALUES = {
  ALL_CLIENTS: 'All Clients',
  ALL_TPAS: 'All TPAs',
  CUSTOM_DATES: 'Custom Dates',
};

export const invoiceFieldLabels: Record<string, string> = {
  'bc.billing_client_name': 'Billing Client Name',
  'bc.billing_client_number': 'Billing Client Number',
  'cl.financial_cutoff_date': 'Financial Cutoff Date',
  'cl.medical_group_number': 'Medical Group Number',
  'cmg.medical_group_name': 'Medical Group Name',
  'cl.location_number': 'Location Number',
  'clo.location_name': 'Location Name',
  'cl.division_number': 'Division Number',
  'cdi.division_name': 'Division Name',
  'cl.fill_date': 'Fill Date',
  'cl.claim_number': 'Claim Number',
  'cl.rx_reversed_claim_number': 'Reversed Claim Number',
  'cl.coverage_code': 'Coverage Code',
  'cl.member_id': 'Member ID',
  'cl.member_name': 'Member Name',
  'cl.ndc': 'NDC',
  'cl.drug_name': 'Drug Name',
  'cl.quantity': 'Quantity',
  'cl.days_supply': 'Days Supply',
  'cl.claim_cost': 'Claim Cost',
  'cl.patient_liability': 'Patient Liability',
  'cl.plan_paid': 'Plan Paid',
  'cl.pos_rebate': 'POS Rebate',
  'cl.rx_number': 'RX Number',
};

export const invoiceFieldCategories = [
  {
    id: 'billing',
    name: 'Client Info',
    fields: ['bc.billing_client_name', 'bc.billing_client_number'],
  },
  {
    id: 'claim',
    name: 'Claim Info',
    fields: [
      'cl.fill_date',
      'cl.claim_number',
      'cl.rx_reversed_claim_number',
      'cl.coverage_code',
      'cl.financial_cutoff_date',
    ],
  },
  {
    id: 'member',
    name: 'Member Info',
    fields: [
      'cl.member_id',
      'cl.member_name',
      'cl.medical_group_number',
      'cmg.medical_group_name',
      'cl.location_number',
      'clo.location_name',
      'cl.division_number',
      'cdi.division_name',
    ],
  },
  {
    id: 'drug',
    name: 'Drug Info',
    fields: ['cl.ndc', 'cl.drug_name', 'cl.quantity', 'cl.days_supply', 'cl.rx_number'],
  },
  {
    id: 'financials',
    name: 'Financials',
    fields: ['cl.claim_cost', 'cl.patient_liability', 'cl.plan_paid', 'cl.pos_rebate'],
  },
];

export const defaultInvoiceConfig = {
  detailed_fields: [
    'bc.billing_client_name',
    'bc.billing_client_number',
    'cl.financial_cutoff_date',
    'cl.medical_group_number',
    'cmg.medical_group_name',
    'cl.fill_date',
    'cl.claim_number',
    'cl.member_id',
    'cl.ndc',
    'cl.drug_name',
    'cl.quantity',
    'cl.days_supply',
    'cl.claim_cost',
    'cl.patient_liability',
    'cl.plan_paid',
  ],
};

export const clientGroupByOptions = [
  { label: 'Member Name', value: ['member_name'] },
  { label: 'Drug Name', value: ['drug_name'] },
  { label: 'Division Number', value: ['division_number'] },
  { label: 'Member Name + Drug Name', value: ['member_name', 'drug_name'] },
  { label: 'Member ID + Member Name', value: ['member_id', 'member_name'] },
  { label: 'Cardholder ID + Member ID', value: ['cardholder_id', 'member_id'] },
  { label: 'Cardholder ID + Cardholder Name', value: ['cardholder_id', 'cardholder_name'] },
  { label: 'Medical Group Number + Medical Group Name', value: ['medical_group_number', 'medical_group_name'] },
  { label: 'Medical Group Name + Member Name', value: ['medical_group_name', 'member_name'] },
  { label: 'Location Name + Member Name', value: ['location_name', 'member_name'] },
  { label: 'Location Name + Location Number', value: ['location_name', 'location_number'] },
  { label: 'Location Number + Member Name', value: ['location_number', 'member_name'] },
  { label: 'Location Number + Medical Group Name + Member Name', value: ['location_number', 'medical_group_name', 'member_name'] },
  { label: 'TOC + Medical Group Name + Fill Date', value: ['toc', 'medical_group_name', 'fill_date'] },
];

export const tpaGroupByOptions = [
  { label: 'Client Name', value: ['client_name'] },
  { label: 'Member Name', value: ['member_name'] },
  { label: 'Drug Name', value: ['drug_name'] },
  { label: 'Division Number', value: ['division_number'] },
  { label: 'Client Name + Member Name', value: ['client_name', 'member_name'] },
  { label: 'Client Name + Drug Name', value: ['client_name', 'drug_name'] },
  {
    label: 'Client Name + Medical Group Name + Location Name',
    value: ['client_name', 'medical_group_name', 'location_name'],
  },
  { label: 'Member Name + Drug Name', value: ['member_name', 'drug_name'] },
  { label: 'Member ID + Member Name', value: ['member_id', 'member_name'] },
  { label: 'Cardholder ID + Member ID', value: ['cardholder_id', 'member_id'] },
  { label: 'Cardholder ID + Cardholder Name', value: ['cardholder_id', 'cardholder_name'] },
  { label: 'Medical Group Number + Medical Group Name', value: ['medical_group_number', 'medical_group_name'] },
  { label: 'Medical Group Name + Member Name', value: ['medical_group_name', 'member_name'] },
  { label: 'Location Name + Member Name', value: ['location_name', 'member_name'] },
  { label: 'Location Name + Location Number', value: ['location_name', 'location_number'] },
  { label: 'Location Number + Member Name', value: ['location_number', 'member_name'] },
  { label: 'Location Number + Medical Group Name + Member Name', value: ['location_number', 'medical_group_name', 'member_name'] },
  { label: 'TOC + Medical Group Name + Fill Date', value: ['toc', 'medical_group_name', 'fill_date'] },
];

export const CLIENT_SPLIT_STRINGS = {
  PAGE_TITLE: 'Manage Client Split',
  MAIN_SCREEN: {
    HEADING: 'Configure Client Split',
    CLIENT_SELECTOR_LABEL: 'Select Client',
    SPLIT_TYPE_LABEL: 'Split Type',
    EFFECTIVE_DATE_LABEL: 'Effective Date',
    SAVE_BUTTON: 'Save Configuration',
    SPLIT_TYPES: {
      TPA: 'TPA Transition',
      BILL_SPLIT: 'Client Bill Split',
      CLEANUP: 'General Data Clean-up',
      BILL_COMBINE: 'Client Bill Combine',
    },
    PLACEHOLDERS: {
      BILL_SPLIT: 'Client Bill Split form will be here.',
      CLEANUP: 'General Data Clean-up form will be here.',
    },
  },
  TPA_FORM: {
    HEADING: 'TPA Transition Details',
    OLD_CLIENT_NAME_LABEL: 'Old Client Name (Editable)',
    NEW_CLIENT_NAME_LABEL: 'New Client Name (Editable)',
    CLIENT_NUMBER_LABEL: 'Client Number',
    OLD_TPA_NAME_LABEL: 'Old TPA Name',
    OLD_TPA_BILLING_NUMBER_LABEL: 'Old TPA Billing Number',
    NEW_TPA_NAME_LABEL: 'New TPA Name',
    NEW_TPA_BILLING_NUMBER_LABEL: 'New TPA Billing Number',
    GP_ID_LABEL: 'GP ID',
  },
};

export const splitTypeOptions = [
  { value: 'tpa', label: CLIENT_SPLIT_STRINGS.MAIN_SCREEN.SPLIT_TYPES.TPA },
  { value: 'combine', label: 'Client Bill Combine' },
  { value: 'split', label: CLIENT_SPLIT_STRINGS.MAIN_SCREEN.SPLIT_TYPES.BILL_SPLIT },
  { value: 'cleanup', label: CLIENT_SPLIT_STRINGS.MAIN_SCREEN.SPLIT_TYPES.CLEANUP },
];

export interface TpaListProps {
  setFunction: (values: RaRecord<Identifier>[]) => void;
  reset?: boolean;
  value: RaRecord<Identifier>[];
}

export const CROSSWALK_SUMMARY_COLUMN_MAPPING = {
  medical_groups: [
    { key: 'medical_group_number', label: 'MG Number', width: '15%' },
    { key: 'medical_group_names_list', label: 'Medical Group Name(s)', width: '45%' },
    { key: 'billing_client_numbers_list', label: 'Billing Client(s)', width: '40%' },
  ],
  locations: [
    { key: 'location_number', label: 'Loc Number', width: '15%' },
    { key: 'location_names_list', label: 'Location Name(s)', width: '45%' },
    { key: 'billing_client_numbers_list', label: 'Billing Client(s)', width: '40%' },
  ],
  divisions: [
    { key: 'division_number', label: 'Div Number', width: '15%' },
    { key: 'division_names_list', label: 'Division Name(s)', width: '45%' },
    { key: 'billing_client_numbers_list', label: 'Billing Client(s)', width: '40%' },
  ],
};

export const paFieldCategories = [
  {
    id: 'member_info',
    name: 'Member Info',
    fields: ['Member Last Name', 'Member First Name', 'Member Id'],
  },
  {
    id: 'drug_info',
    name: 'Drug Info',
    fields: ['Drug Name/Strength', 'Clinical/Specialty'],
  },
  {
    id: 'financials',
    name: 'Financials',
    fields: ['Charge Amount'],
  },
];

export const paFieldLabels: Record<string, string> = {
  'Member Last Name': 'Member Last Name',
  'Member First Name': 'Member First Name',
  'Member Id': 'Member Id',
  'Drug Name / Strength': 'Drug Name/Strength',
  'Clinical / Specialty': 'Clinical/Specialty',
  'Charge Amount': 'Charge Amount',
};

export const assistFieldCategories = [
  {
    id: 'member_info',
    name: 'Member Info',
    fields: ['member_id', 'member_name'],
  },
  {
    id: 'drug_info',
    name: 'Drug Info',
    fields: ['drug_name', 'quantity', 'days_supply', 'fill_date'],
  },
  {
    id: 'financials',
    name: 'Financials',
    fields: ['plan_cost_without_ta', 'plan_cost_with_ta', 'plan_cost_savings', 'savings_billed'],
  },
];

export const assistFieldLabels: Record<string, string> = {
  member_id: 'Member ID',
  member_name: 'Member Name',
  drug_name: 'Drug Name',
  quantity: 'Quantity',
  days_supply: 'Days Supply',
  fill_date: 'Fill Date',
  plan_cost_without_ta: 'Plan Cost (Without TA)',
  plan_cost_with_ta: 'Plan Cost (With TA)',
  plan_cost_savings: 'Plan Cost Savings',
  savings_billed: 'Savings Billed',
};

// constants/invoiceLayouts.ts
export const INVOICE_LAYOUTS: Record<string, { id: string; label: string; fields: string[] }> = {
  default: {
    id: 'default',
    label: 'Default',
    fields: [
      'bc.billing_client_name',
      'bc.billing_client_number',
      'cl.fill_date',
      'cl.financial_cutoff_date',
      'cl.claim_number',
      'cl.member_id',
      'cl.medical_group_number',
      'cmg.medical_group_name',
      'cl.ndc',
      'cl.drug_name',
      'cl.quantity',
      'cl.days_supply',
      'cl.claim_cost',
      'cl.patient_liability',
      'cl.plan_paid',
    ],
  },

  layout_2: {
    id: 'layout_2',
    label: 'Default + Location',
    fields: ['cl.location_number', 'clo.location_name'],
  },

  layout_3: {
    id: 'layout_3',
    label: 'Default + Patient Name + Location',
    fields: ['cl.member_name', 'cl.location_number', 'clo.location_name'],
  },

  layout_4: {
    id: 'layout_4',
    label: 'Default + Location + Coverage Tier',
    fields: ['cl.location_number', 'clo.location_name', 'cl.coverage_code'],
  },

  layout_5: {
    id: 'layout_5',
    label: 'Default + Patient Name',
    fields: ['cl.member_name'],
  },

  layout_6: {
    id: 'layout_6',
    label: 'Default + Patient Name + POS',
    fields: ['cl.member_name', 'cl.pos_rebate'],
  },

  layout_7: {
    id: 'layout_7',
    label: 'Default + Reversed Claim',
    fields: ['cl.rx_reversed_claim_number'],
  },

  layout_8: {
    id: 'layout_8',
    label: 'Default + Rx Number',
    fields: ['cl.rx_number'],
  },
};
